import Vue from "vue";
import Router from "vue-router";
import config from "@/config";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: () => import("@/views/default/index.vue"),
      children: [
        {
          path: "",
          redirect: "/login"
          // component: () => import("@/views/default/_home.vue")
        },
        {
          path: "/login",
          component: () => import("@/views/default/_login.vue")
        },
        {
          path: "/logout",
          component: () => import("@/views/default/_logout.vue")
        },
        {
          path: "/expired",
          component: () => import("@/views/default/_expired.vue")
        },
        {
          path: "/denied",
          component: () => import("@/views/default/_denied.vue")
        },
        {
          path: "/attachment",
          component: () => import("@/views/default/_attachment.vue"),
          props: true
        },
        {
          path: "/firstTime",
          component: () => import("@/views/default/_firstTime.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/security",
          component: () => import("@/views/default/_security.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/resetPassword",
          component: () => import("@/views/default/_resetPassword.vue"),
          meta: { requiredLoggedIn: true}
        }
      ]
    },
    {
      path: "/ticket",
      component: () => import("@/views/ticket/index.vue"),
      children: [
        {
          path: "/ticket/ticketList",
          component: () => import("@/views/ticket/_ticketList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlist], subAccPage: [config.subAccessRoles.ticket] }
        },
        {
          path: "/ticket/pendingTicket",
          component: () => import("@/views/ticket/_pendingTicket.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.pendingticket], subAccPage: [config.subAccessRoles.ticket] }
        },
        {
          path: "/ticket/ticketListAutoWithdrawal",
          component: () => import("@/views/ticket/_ticketListAutoWithdrawal.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistautowithdrawal], subAccPage: [config.subAccessRoles.ticket] }
        },
        {
          path: "/ticket/ticketListReviewAudit",
          component: () => import("@/views/ticket/_ticketListReviewAudit.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistreviewaudit], subAccPage: [config.subAccessRoles.ticket] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlist, config.accessRoles.pendingticket, config.accessRoles.ticketlistautowithdrawal, config.accessRoles.ticketlistreviewaudit], subAccPage: [config.subAccessRoles.ticket] }
    },
    {
      path: "/bank",
      component: () => import("@/views/bank/index.vue"),
      children: [
        {
          path: "/bank/bankGroup",
          component: () => import("@/views/bank/_bankGroup.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankgroup], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/paymentOption",
          component: () => import("@/views/bank/_paymentOption.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.paymentoption], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/bankOperator",
          component: () => import("@/views/bank/_bankOperator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankoperator], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/bankMember",
          component: () => import("@/views/bank/_bankMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankmember], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/bankMemberEWallet",
          component: () => import("@/views/bank/_bankMemberEWallet.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankmemberewallet], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/bankProvider",
          component: () => import("@/views/bank/_bankProvider.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankprovider], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/bankDefaultSender",
          component: () => import("@/views/bank/_bankDefaultSender.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankdefaultsender], subAccPage: [config.subAccessRoles.bank] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankoperator, config.accessRoles.bankmember, config.accessRoles.bankmemberewallet], subAccPage: [config.subAccessRoles.bank] }
    },
    {
      path: "/rescuefund",
      component: () => import("@/views/rescuefund/index.vue"),
      children: [
        {
          path: "/rescuefund",
          component: () => import("@/views/rescuefund/_rescueFund.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rescuefund], subAccPage: [config.subAccessRoles.rescuefund] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rescuefund], subAccPage: [config.subAccessRoles.rescuefund] }
    },
    {
      path: "/turnovertier",
      component: () => import("@/views/turnovertier/index.vue"),
      children: [
        {
          path: "/turnovertier",
          component: () => import("@/views/turnovertier/_turnovertier.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.turnovertier], subAccPage: [config.subAccessRoles.turnovertier] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.turnovertier], subAccPage: [config.subAccessRoles.turnovertier] }
    },
    {
      path: "/vip",
      component: () => import("@/views/vip/index.vue"),
      children: [
        {
          path: "/vip",
          component: () => import("@/views/vip/_vip.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.vip], subAccPage: [config.subAccessRoles.vip] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.vip], subAccPage: [config.subAccessRoles.vip] }
    },
    {
      path: "/setup",
      component: () => import("@/views/setup/index.vue"),
      children: [
        {
          path: "/setup/providerMaintenance",
          component: () => import("@/views/setup/_providerMaintenance.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providermaintenance], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/providerBetLimit",
          component: () => import("@/views/setup/_providerBetLimit.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerbetlimit], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/providerGameOff",
          component: () => import("@/views/setup/_providerGameOff.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providergameoff], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/providerRtp",
          component: () => import("@/views/setup/_providerRtp.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerrtp], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/withdrawalLimit",
          component: () => import("@/views/setup/_withdrawalLimit.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.withdrawallimit], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/globalSetting",
          component: () => import("@/views/setup/_globalSetting.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.globalsetting], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/systemBalance",
          component: () => import("@/views/setup/_systemBalance.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.systembalance], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/iframe",
          component: () => import("@/views/setup/_iframe.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.iframe], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/exchangeRate",
          component: () => import("@/views/setup/_exchangeRate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.exchangerate], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/gameNameExclude",
          component: () => import("@/views/setup/_gameNameExclude.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gamenameexclude], subAccPage: [config.subAccessRoles.setup] }
        },
        {
          path: "/setup/logRepulling",
          component: () => import("@/views/setup/_logRepulling.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.logrepulling], subAccPage: [config.subAccessRoles.setup] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providermaintenance,config.accessRoles.providerbetlimit,config.accessRoles.withdrawallimit,config.accessRoles.providergameoff], subAccPage: [config.subAccessRoles.setup] }
    },
    {
      path: "/promotion",
      component: () => import("@/views/promotion/index.vue"),
      children: [
        {
          path: "/promotion/promoGroup",
          component: () => import("@/views/promotion/_promoGroup.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promogroup], subAccPage: [config.subAccessRoles.promotion] }
        },
        {
          path: "/promotion/promoAccount",
          component: () => import("@/views/promotion/_promoAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promoaccount], subAccPage: [config.subAccessRoles.promotion] }
        },
        {
          path: "/promotion/promoMember",
          component: () => import("@/views/promotion/_promoMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promomember], subAccPage: [config.subAccessRoles.promotion] }
        },
        {
          path: "/promotion/promoSignup",
          component: () => import("@/views/promotion/_promoSignup.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promosignup], subAccPage: [config.subAccessRoles.promotion] }
        },
        {
          path: "/promotion/coupon",
          component: () => import("@/views/promotion/_coupon.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.coupon], subAccPage: [config.subAccessRoles.promotion] }
        },
        {
          path: "/promotion/campaign",
          component: () => import("@/views/promotion/_campaign.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.campaign], subAccPage: [config.subAccessRoles.promotion] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promoaccount, config.accessRoles.promomember, config.accessRoles.coupon, config.accessRoles.campaign], subAccPage: [config.subAccessRoles.promotion] }
    },
    {
      path: "/account",
      component: () => import("@/views/account/index.vue"),
      children: [
        {
          path: "/account/operator",
          component: () => import("@/views/account/_operator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.operator], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/memberList",
          component: () => import("@/views/account/_memberList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.memberlist], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/memberDetails",
          component: () => import("@/views/account/_memberDetails.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.memberdetails], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/subAccount",
          component: () => import("@/views/account/_subAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.subaccount], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/socialAccount",
          component: () => import("@/views/account/_socialAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.socialaccount], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/ipWhitelist",
          component: () => import("@/views/account/_ipWhitelist.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ipwhitelist], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/memberBonus",
          component: () => import("@/views/account/_memberBonus.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.memberbonus], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/memberCustomVip",
          component: () => import("@/views/account/_memberCustomVip.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.membercustomvip], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/memberLabel",
          component: () => import("@/views/account/_memberLabel.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.memberlabel], subAccPage: [config.subAccessRoles.account] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.memberlist, config.accessRoles.memberdetails, config.accessRoles.operator, config.accessRoles.subaccount,
                                                      config.accessRoles.socialaccount, config.accessRoles.ipwhitelist, config.accessRoles.memberbonus, config.accessRoles.membercustomvip], subAccPage: [config.subAccessRoles.account]}
    },
    {
      path: "/system",
      component: () => import("@/views/system/index.vue"),
      children: [
        {
          path: "/system/setting",
          component: () => import("@/views/system/_setting.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/system/dashboard",
          component: () => import("@/views/system/_dashboard.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dashboard], subAccPage: [config.subAccessRoles.system] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [], subAccPage: [config.subAccessRoles.system]}
    },
    {
      path: "/review",
      component: () => import("@/views/review/index.vue"),
      children: [
        {
          path: "/review/reviewList",
          component: () => import("@/views/review/_reviewList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.reviewlist], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/review/monthlyrating",
          component: () => import("@/views/review/_monthlyRating.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.monthlyrating], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/review/surveyList",
          component: () => import("@/views/review/_surveyList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.surveylist], subAccPage: [config.subAccessRoles.account] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.reviewlist, config.accessRoles.monthlyrating], subAccPage: [config.subAccessRoles.account] }
    },
    {
      path: "/cms",
      component: () => import("@/views/cms/index.vue"),
      children: [
        {
          path: "/cms/announcementBanner",
          component: () => import("@/views/cms/_announcementBanner.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.announcementbanner], subAccPage: [config.subAccessRoles.cms] }
        },
        {
          path: "/cms/promotionBanner",
          component: () => import("@/views/cms/_promotionBanner.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotionbanner], subAccPage: [config.subAccessRoles.cms] }
        },
        {
          path: "/cms/slideBanner",
          component: () => import("@/views/cms/_slideBanner.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.slidebanner], subAccPage: [config.subAccessRoles.cms] }
        },
        {
          path: "/cms/seoPage",
          component: () => import("@/views/cms/_seoPage.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.seopage], subAccPage: [config.subAccessRoles.cms] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.announcementbanner, config.accessRoles.promotionbanner, config.accessRoles.slidebanner, config.accessRoles.seopage], subAccPage: [config.subAccessRoles.cms] }
    },
    {
      path: "/affiliate",
      component: () => import("@/views/affiliate/index.vue"),
      children: [
        {
          path: "/affiliate/dashboardAffiliate",
          component: () => import("@/views/affiliate/_dashboardAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dashboardaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/approveAffiliate",
          component: () => import("@/views/affiliate/_approveAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.approveaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/affiliateList",
          component: () => import("@/views/affiliate/_affiliateList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.affiliatelist], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/globalSettingAffiliate",
          component: () => import("@/views/affiliate/_globalSettingAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.globalsettingaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/bankAffiliate",
          component: () => import("@/views/affiliate/_bankAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/ticketListAffiliate",
          component: () => import("@/views/affiliate/_ticketListAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/pendingTicketAffiliate",
          component: () => import("@/views/affiliate/_pendingTicketAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.pendingticketaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/ticketListReviewAuditAffiliate",
          component: () => import("@/views/affiliate/_ticketListReviewAuditAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistreviewauditaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/dailyWithdrawalAffiliate",
          component: () => import("@/views/affiliate/_dailyWithdrawalAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywithdrawalaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/adjustmentLogAffiliate",
          component: () => import("@/views/affiliate/_adjustmentLogAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.adjustmentlogaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/settlementLogAffiliate",
          component: () => import("@/views/affiliate/_settlementLogAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlementlogaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/settlementListAffiliate",
          component: () => import("@/views/affiliate/_settlementListAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlementlistaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/adjustmentListAffiliate",
          component: () => import("@/views/affiliate/_adjustmentListAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.adjustmentlistaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/dailyStatementAffiliate",
          component: () => import("@/views/affiliate/_dailyStatementAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailystatementaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        // {
        //   path: "/affiliate/settlementListAffiliate",
        //   component: () => import("@/views/affiliate/_settlementListAffiliate.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.settlementlistaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        // },
        {
          path: "/affiliate/dailyWinLoseAffiliate",
          component: () => import("@/views/affiliate/_dailyWinLoseAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinloseaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        },
        {
          path: "/affiliate/dailyDepositAffiliate",
          component: () => import("@/views/affiliate/_dailyDepositAffiliate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailydepositaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        }
        // {
        //   path: "/affiliate/dailyWinLoseMemberAffiliate",
        //   component: () => import("@/views/affiliate/_dailyWinLoseMemberAffiliate.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinlosememberaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        // },
        // {
        //   path: "/affiliate/commUpdateLogAffiliate",
        //   component: () => import("@/views/affiliate/_commUpdateLogAffiliate.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.commupdatelogaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
        // },
        // {
        //   path: "/affiliate/playerList",
        //   component: () => import("@/views/affiliate/_playerList.vue"),
        //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.playerlist], subAccPage: [config.subAccessRoles.affiliate] }
        // },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.approveaffiliate, config.accessRoles.affiliatelist, config.accessRoles.bankaffiliate,
                                                      config.accessRoles.ticketaffiliate, config.accessRoles.settlementlistaffiliate, config.accessRoles.playerlist,
                                                      config.accessRoles.dailywinloseaffiliate, config.accessRoles.dailywinlosememberaffiliate, config.accessRoles.commupdatelogaffiliate], subAccPage: [config.subAccessRoles.affiliate] }
    },
    {
      path: "/log",
      component: () => import("@/views/log/index.vue"),
      children: [
        {
          path: "/log/adjustMemberLog",
          component: () => import("@/views/log/_adjustMemberLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.adjustmemberlog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/issueBonusLog",
          component: () => import("@/views/log/_issueBonusLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.issuebonuslog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/gameResultChangesLog",
          component: () => import("@/views/log/_gameResultChangesLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gameresultchangeslog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/ticketLogAutoWithdrawal",
          component: () => import("@/views/log/_ticketLogAutoWithdrawal.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlogautowithdrawal], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/loginMemberLog",
          component: () => import("@/views/log/_loginMemberLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.loginmemberlog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/memberVipLog",
          component: () => import("@/views/log/_memberVipLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.memberviplog], subAccPage: [config.subAccessRoles.log] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.adjustmemberlog, config.accessRoles.issuebonuslog, config.accessRoles.memberviplog], subAccPage: [config.subAccessRoles.log] }
    },
    {
      path: "/report",
      component: () => import("@/views/report/index.vue"),
      children: [
        {
          path: "/report",
          redirect: "/report/dailyStatement"
        },
        {
          path: "/report/dailyStatement",
          component: () => import("@/views/report/_dailyStatement.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailystatement], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailyWinLose",
          component: () => import("@/views/report/_dailyWinLose.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinlose], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/platformWinLose",
          component: () => import("@/views/report/_platformWinLose.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.platformwinlose], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/providerWinLoseCompany",
          component: () => import("@/views/report/_providerWinLoseCompany.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerwinlosecompany], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/providerWinLoseMember",
          component: () => import("@/views/report/_providerWinLoseMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.providerwinlosemember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailySummaryCompany",
          component: () => import("@/views/report/_dailySummaryCompany.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailysummarycompany], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailySummaryMember",
          component: () => import("@/views/report/_dailySummaryMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailysummarymember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/gameResultSlots",
          component: () => import("@/views/report/_gameResultSlots.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gameresultslots], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/gameResultLivecasino",
          component: () => import("@/views/report/_gameResultLivecasino.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gameresultlivecasino], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/gameResultRebate",
          component: () => import("@/views/report/_gameResultRebate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gameresultrebate], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/gameResultSportsbook",
          component: () => import("@/views/report/_gameResultSportsbook.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gameresultsportsbook], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/gameResultCockfight",
          component: () => import("@/views/report/_gameResultCockfight.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gameresultcockfight], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/gameResultRescue",
          component: () => import("@/views/report/_gameResultRescue.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gameresultrescue], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/bankStatement",
          component: () => import("@/views/report/_bankStatement.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankstatement], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/bankStatementDaily",
          component: () => import("@/views/report/_bankStatementDaily.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankstatementdaily], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/oneTimeDepositor",
          component: () => import("@/views/report/_oneTimeDepositor.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.onetimedepositor], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/currentMonthNonDepositor",
          component: () => import("@/views/report/_currentMonthNonDepositor.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.currentmonthnondepositor], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/currentMonthNoLogin",
          component: () => import("@/views/report/_currentMonthNoLogin.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.currentmonthnologin], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionSummary",
          component: () => import("@/views/report/_promotionSummary.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotionsummary], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/refereeList",
          component: () => import("@/views/report/_refereeList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.refereelist], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/bonusList",
          component: () => import("@/views/report/_bonusList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bonuslist], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/adjustmentList",
          component: () => import("@/views/report/_adjustmentList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.adjustmentlist], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionSignupUnusedList",
          component: () => import("@/views/report/_promotionSignupUnusedList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotionsignupunusedlist], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionSignupOngoing",
          component: () => import("@/views/report/_promotionSignupOngoing.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotionsignupongoing], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/depositedMember",
          component: () => import("@/views/report/_depositedMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.depositedmember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/registeredMember",
          component: () => import("@/views/report/_registeredMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.registeredmember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/firstDeposit",
          component: () => import("@/views/report/_firstDeposit.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.firstdeposit], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/memberExport",
          component: () => import("@/views/report/_memberExport.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.memberexport], subAccPage: [config.subAccessRoles.export_excel] }
        },
        {
          path: "/report/ticketExport",
          component: () => import("@/views/report/_ticketExport.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketexport], subAccPage: [config.subAccessRoles.export_excel] }
        },
        {
          path: "/report/crmList",
          component: () => import("@/views/report/_crmList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.crmlist], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/ticketWalletTransList",
          component: () => import("@/views/report/_ticketWalletTransList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketwallettranslist], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/utmList",
          component: () => import("@/views/report/_utmList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.utmlist], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/rebateSummary",
          component: () => import("@/views/report/_rebateSummary.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rebatesummary], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/rebateSummaryv2",
          component: () => import("@/views/report/_rebateSummaryv2.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rebatesummaryv2], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/rebateListMember",
          component: () => import("@/views/report/_rebateListMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rebateslistmember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailyWinLoseSB",
          component: () => import("@/views/report/_dailyWinLoseSB.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinlosesb], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailyWinLoseSBDetail",
          component: () => import("@/views/report/_dailyWinLoseSBDetail.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinlosesbdetail], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/smarticoBonusReport",
          component: () => import("@/views/report/_smarticoBonusReport.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.smarticobonusreport], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/smarticoBonusReportExpired",
          component: () => import("@/views/report/_smarticoBonusReportExpired.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.smarticobonusreportexpired], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/ticketListAutoWithdrawalExport",
          component: () => import("@/views/report/_ticketListAutoWithdrawalExport.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticketlistautowithdrawalexport], subAccPage: [config.subAccessRoles.export_excel] }
        },
        {
          path: "/report/retention",
          component: () => import("@/views/report/_retention.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.retention], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/cohort",
          component: () => import("@/views/report/_cohort.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.cohort], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionWithdrawalSummary",
          component: () => import("@/views/report/_promotionWithdrawalSummary.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotionwithdrawalsummary], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/uniqueLogin",
          component: () => import("@/views/report/_uniqueLogin.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.uniquelogin], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/uniqueWithdrawal",
          component: () => import("@/views/report/_uniqueWithdrawal.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.uniquewithdrawal], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/secondDeposit",
          component: () => import("@/views/report/_secondDeposit.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.seconddeposit], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/rescueFundPayout",
          component: () => import("@/views/report/_rescueFundPayout.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.rescuefundpayout], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailyWinLoseGame",
          component: () => import("@/views/report/_dailyWinLoseGame.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinlosegame], subAccPage: [config.subAccessRoles.report] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.refereelist], subAccPage: [config.subAccessRoles.report, config.subAccessRoles.export_excel] }
    }
  ]
});

export default router;
